module.exports = "/assets/d2f830b5d17b0c5938459d1d77dd58e4.png";